
import React, { useRef } from "react";
import styled from 'styled-components';
import { AgGridReact } from 'ag-grid-react';
import { AgGridReact as AgGridReactType } from 'ag-grid-react';
import { type ColDef, themeAlpine  } from 'ag-grid-community';
import '@process-advisor/process-miner/shared/gridStyles.css'
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

const Wrapper = styled.div<{ height: string }>`
    height: ${({ height }) => height};
    width: 100%;
    margin-bottom: 5px;
`;

type SingleRow = {
    id: number;
    [key: string]: any
}

type Props = {
    rows: SingleRow[];
    columns: ColDef[];
    height: string;
}

export const DataGrid: React.FC<Props> = ({
    rows,
    columns,
    height,
}) => {

    const grid = useRef<AgGridReactType>(null);

    const onModelUpdated = (params) => {
        params.api.autoSizeAllColumns();
    }

    const statusBar = {
        statusPanels: [
            {
                statusPanel: 'agTotalAndFilteredRowCountComponent',
                align: 'left',
            }
        ]
    };
    
    const getMainMenuItems = (params) => {
        const DefaultMenuItems = params.defaultItems.slice(0);
        const NewMenuItems = []
            NewMenuItems.push({
                name: 'Map column',
                    subMenu: [
                    {
                        name: apiProvider.getEntityUpper() + ' ID',
                        action: () => {
                            params.column.colDef.mapping = apiProvider.getEntityUpper() + ' ID'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === apiProvider.getEntityUpper() + ' ID'
                    },
                    {
                        name: 'Activity Type',
                        action: () => {
                            params.column.colDef.mapping = 'Activity Type'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Activity Type'
                    },
                    {
                        name: 'Work Type',
                        action: () => {
                            params.column.colDef.mapping = 'Work Type'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Work Type'
                    },
                    {
                        name: 'Activity',
                        action: () => {
                            params.column.colDef.mapping = 'Activity'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Activity'
                    },
                    {
                        name: 'Timestamp',
                        action: () => {
                            params.column.colDef.mapping = 'Timestamp'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Timestamp'
                    },
                    {
                        name: apiProvider.getEntityUpper() + ' Create Time',
                        action: () => {
                            params.column.colDef.mapping = apiProvider.getEntityUpper() + ' Create Time'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === apiProvider.getEntityUpper() + ' Create Time'
                    },
                    {
                        name: apiProvider.getEntityUpper() + ' Close Time',
                        action: () => {
                            params.column.colDef.mapping = apiProvider.getEntityUpper() + ' Close Time'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === apiProvider.getEntityUpper() + ' Close Time'
                    },
                    {
                        name: 'Resource',
                        action: () => {
                            params.column.colDef.mapping = 'Resource'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Resource'
                    },
                    {
                        name: apiProvider.getEntityUpper() + ' Attribute',
                        action: () => {
                            params.column.colDef.mapping = apiProvider.getEntityUpper() + ' Attribute'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === apiProvider.getEntityUpper() + ' Attribute'
                    },
                    {
                        name: 'Event Attribute',
                        action: () => {
                            params.column.colDef.mapping = 'Event Attribute'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Event Attribute'
                    },
                    {
                        name: 'Metric - True/False',
                        action: () => {
                            params.column.colDef.mapping = 'Metric - True/False'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Metric - True/False'
                    },
                    {
                        name: 'Metric - Duration',
                        action: () => {
                            params.column.colDef.mapping = 'Metric - Duration'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Metric - Duration'
                    },                    
                    {
                        name: 'Metric - Amount',
                        action: () => {
                            params.column.colDef.mapping = 'Metric - Amount'
                            apiProvider.setDataMapping({field: params.column.colDef.headerName,  mapping: params.column.colDef.mapping});
                        },
                        checked:  params.column.colDef.mapping === 'Metric - Amount'
                    },                    
                    ],
                });
                NewMenuItems.push({
                    name: 'Data Type',
                        subMenu: [
                        {
                            name: 'Text',
                            action: () => {
                                params.column.colDef.dataType = 'Text'
                                apiProvider.setDataType({field: params.column.colDef.headerName,  type: params.column.colDef.dataType});
                            },
                            checked: params.column.colDef.dataType === 'Text'
                        },
                        {
                            name: 'Number',
                            action: () => {
                                params.column.colDef.dataType = 'Number'
                                apiProvider.setDataType({field: params.column.colDef.headerName,  type: params.column.colDef.dataType});
                            },
                            checked:  params.column.colDef.dataType === 'Number'
                        },
                        {
                            name: 'DateTime',
                            action: () => {
                                params.column.colDef.dataType = 'Datetime'
                                apiProvider.setDataType({field: params.column.colDef.headerName,  type: params.column.colDef.dataType});
                            },
                            checked:  params.column.colDef.dataType === 'Datetime'
                        },
                        ],
                    });
                        
        NewMenuItems.push(DefaultMenuItems[1])
        NewMenuItems.push(DefaultMenuItems[2])
        NewMenuItems.push(DefaultMenuItems[3])
        NewMenuItems.push(DefaultMenuItems[4])
        return NewMenuItems;
    };

    return (
        <Wrapper height={height}>
            <div
                
                style={{
                    height: '100%',
                    width: '100%',
                    fontFamily: 'system-ui'
,
                }}>
                <AgGridReact theme={themeAlpine} 
                    statusBar={statusBar}
                    columnDefs={columns}
                    headerHeight={40}
                    suppressMenuHide={true}
                    getMainMenuItems={getMainMenuItems}
                    onModelUpdated={onModelUpdated}
                    ref={grid}
                    sideBar={
                        {
                            toolPanels: [
                                {
                                    id: 'columns',
                                    labelDefault: 'Columns',
                                    labelKey: 'columns',
                                    iconKey: 'columns',
                                    toolPanel: 'agColumnsToolPanel',
                                    toolPanelParams: {
                                        suppressRowGroups: true,
                                        suppressValues: true,
                                        suppressPivotMode: true, 
                                    }
                      
                                },
                                {
                                    id: 'filters',
                                    labelDefault: 'Filters',
                                    labelKey: 'filters',
                                    iconKey: 'filter',
                                    toolPanel: 'agFiltersToolPanel',
                                },
                            ],
                            hiddenByDefault: false,
                            defaultToolPanel: '',
                        }
                    }                    
                    defaultColDef={{
                        editable: false,
                        sortable: true,
                        flex: 1,
                        minWidth: 100,
                        filter: true,
                        resizable: true,
                        menuTabs: ['generalMenuTab','filterMenuTab'],
                    }}
                    rowData={rows} />
            </div>
        </Wrapper>
    );
};
